module.exports = __webpack_public_path__ + "src/assets/images/Toolkit2.png";